export default __webpack_public_path__ + "static/media/resume 4_21_21.8f61e39c.pdf";